import React, { useState, useEffect } from "react";
import 'react-quill/dist/quill.snow.css';
import GlobalStyles from 'styles/GlobalStyles';
import SignUp from './components/Signup.js';
import Login from './components/Login.js';
import RestaurantLandingPage from './components/RestaurantLandingPage.js';
import TermsOfService from './components/TermsOfService.js';
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import Boutique from "components/Boutique.js";
import './Boutique.css';
import './ProductDetails.css';
import './Checkout.css';
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import ProductDetails from "components/ProductDetails.js";
import CheckoutFrom from "components/CheckoutForm.js";
import ForgotPassword from "components/ForgotPassword.js";
import ResetPassword from "components/ResetPassword.js";
import Orders from "components/Admin/Orders.jsx";
import Profile from "components/Admin/Profile.js";
import OrdersAdmin from "components/AdminDashbord/Orders.jsx";
import ProduitsAdmin from "components/AdminDashbord/Produits.jsx";
import DashbordAdmin from "components/AdminDashbord/Dashbord.jsx";
import PaymentAdmin from "components/AdminDashbord/Payment.jsx";
import UserAdmin from "components/AdminDashbord/UserAdmin.jsx";
import ClientAdmin from "components/AdminDashbord/ClientAdmin.jsx";
import Retraite from "components/AdminDashbord/Retraite.jsx";
import ProtectedRoute from "./ProtectedRoute"; // Import ProtectedRoute component
import Contact from "Contact.js";
import AboutLadyCosmeticos from "components/propos.jsx";
import "@fortawesome/fontawesome-free/css/all.min.css";
import WhatsAppButton from "components/WhatsAppButton.jsx";
import AdminAnnouncement from "components/AdminDashbord/AdminAnnouncement.jsx";
import Cosmetique from './components/cards/Cosmetique.js';
import Complements from './components/cards/Complement.js';
import Packs from './components/cards/Packs.js';
import './i18n'; // <-- this runs the i18n config
import LanguageSwitcher from "components/LanguageSwitcher.jsx";
import i18n from "./i18n"; // adjust path if needed

export default function App() {
  const [role, setRole] = useState(null);
   useEffect(() => {
    const currentLang = i18n.language;
    const dir = currentLang === "ar" ? "rtl" : "ltr";
    document.documentElement.setAttribute("dir", dir);
    document.documentElement.setAttribute("lang", currentLang);
  }, [i18n.language]);

  useEffect(() => {
    const storedRole = localStorage.getItem('isAdmin'); 
    if (storedRole !== null) {
      setRole(storedRole);
    } else {
      setRole(''); 
    }
  }, []);

  if (role === null) {
    return <div>Loading...</div>;
  }


  return (
    <>
     <LanguageSwitcher />

      <GlobalStyles />
      <Router>
        <Routes>
          {/* Public routes */}
          <Route path="/" element={<RestaurantLandingPage />} />
          <Route path="/signup" element={<SignUp />} />
          <Route path="/login" element={<Login />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/terms-of-service" element={<TermsOfService />} />
          <Route path="/contact" element={<Contact/>} />
          <Route path="/Boutique" element={<Boutique/>} />
          <Route path="/à-props" element={<AboutLadyCosmeticos/>} />

     <Route path="/Cosmetique" element={<Cosmetique/>} />
          <Route path="/Complements" element={<Complements/>} />
          <Route path="/Packs" element={<Packs/>} />

        
          <Route
            path="/product-details/:id"
            element={
              // <ProtectedRoute allowedRoles={['0']}>
                <ProductDetails />
              // </ProtectedRoute>
            }
          />
          <Route
            path="/checkout"
            element={
              // <ProtectedRoute allowedRoles={['0']}>
                <CheckoutFrom />
              // </ProtectedRoute>
            }
          />
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute allowedRoles={['0']}>
                <Orders />
              </ProtectedRoute>
            }
          />
          <Route
            path="/profile"
            element={
              <ProtectedRoute allowedRoles={['0']}>
                <Profile />
              </ProtectedRoute>
            }
          />
   <Route
            path="/admin-announcement"
            element={
              <ProtectedRoute allowedRoles={['1']}>
                <AdminAnnouncement/>
              </ProtectedRoute>
            }
          />
          {/* Admin-only routes */}
          <Route
            path="/dashbord-admin"
            element={
              <ProtectedRoute allowedRoles={['1']}>
                <DashbordAdmin />
              </ProtectedRoute>
            }
          />
          <Route
            path="/order-admin"
            element={
              <ProtectedRoute allowedRoles={['1']}>
                <OrdersAdmin />
              </ProtectedRoute>
            }
          />
          <Route
            path="/produits-admin"
            element={
              <ProtectedRoute allowedRoles={['1']}>
                <ProduitsAdmin />
              </ProtectedRoute>
            }
          />
          <Route
            path="/payment-admin"
            element={
              <ProtectedRoute allowedRoles={['1']}>
                <PaymentAdmin />
              </ProtectedRoute>
            }
          />
          <Route
            path="/user-admin"
            element={
              <ProtectedRoute allowedRoles={['1']}>
                <UserAdmin />
              </ProtectedRoute>
            }
          />
          <Route
            path="/client-admin"
            element={
              <ProtectedRoute allowedRoles={['1']}>
                <ClientAdmin />
              </ProtectedRoute>
            }
          />
          <Route
            path="/retraite"
            element={
              <ProtectedRoute allowedRoles={['1']}>
                <Retraite />
              </ProtectedRoute>
            }
          />
             

        </Routes>
      </Router>
          <WhatsAppButton />

    </>
  );
}